var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{
    [`v-application--${_vm.themeName}`]: true,
    [`v-application--3ds-mode`]: _vm.is3DSMode,
  },attrs:{"id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }